import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=50f0aef4&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=ts"
export * from "./spinner.vue?vue&type=script&lang=ts"
import style0 from "./spinner.scss?vue&type=style&index=0&id=50f0aef4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0aef4",
  null
  
)

export default component.exports